import React from 'react';
import { Sun, Moon, Languages } from 'lucide-react';
import { useTheme } from "next-themes";
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import NotificationPanel from '../NotificationPanel';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export default function NavActions() {
  const { setTheme, theme } = useTheme();
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.resolvedLanguage || i18n.language || 'en';

  return (
    <div className="flex items-center gap-1.5 sm:gap-2">
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")} 
        className="h-9 w-9 text-muted-foreground hover:text-foreground hidden sm:flex border border-transparent hover:border-border/50 hover:bg-accent/40 rounded-xl transition-all"
      >
        <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
        <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            title={t('nav.language')}
            className="relative h-9 w-9 text-muted-foreground hover:text-foreground border border-transparent hover:border-border/50 hover:bg-accent/40 rounded-xl transition-all"
          >
            <Languages className="h-4 w-4" />
            <span className="absolute bottom-1 right-1 text-[8px] font-bold uppercase opacity-80">
              {currentLanguage.slice(0, 2)}
            </span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-44 rounded-xl border-border/60 p-2 shadow-xl">
          <DropdownMenuLabel className="px-2 py-1 text-xs font-bold uppercase tracking-widest text-muted-foreground">
            {t('nav.chooseLanguage')}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuRadioGroup value={currentLanguage.slice(0, 2)} onValueChange={(value) => i18n.changeLanguage(value)}>
            <DropdownMenuRadioItem value="tr" className="rounded-lg px-8 py-2.5 text-sm font-medium">
              {t('nav.turkish')}
            </DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="en" className="rounded-lg px-8 py-2.5 text-sm font-medium">
              {t('nav.english')}
            </DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Notification Panel */}
      <NotificationPanel />
    </div>
  );
}
